import React from 'react';
import { withAuthAdmin } from '../../hooks/useAuthAdmin';
import AdminLayout from '../../components/ui/AdminLayout';
import { useLocation } from 'react-router-dom';

import Dashboard from './components/Dashboard';
import Users from './components/Users';
import Orders from './components/Orders';
import Products from './components/Products';
import Events from './components/Events';
import Activity from './components/Activity';

function AdminDashboard() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const component = queryParams.get('component');

  let renderedComponent;
  if (component === 'users') {
    renderedComponent = <Users />;
  } else if (component === 'orders') {
    renderedComponent = <Orders />;
  } else if (component === 'products') {
    renderedComponent = <Products />;
  } else if (component === 'activity') { 
    renderedComponent = <Activity />;
  } else if (component === 'events') {
    renderedComponent = <Events />;
  } else {
    renderedComponent = <Dashboard />;
  }

  return (
    <section className="relative h-screen bg-secondary-background text-[#121212] w-full bg-[#e5e4e4]">
      <AdminLayout>
        <div className="w-full flex justify-center mt-5">
          {renderedComponent}
        </div>
      </AdminLayout>
    </section>
  );
}

export default withAuthAdmin(AdminDashboard);